import "./MatrixLogo.css";

const MatrixLogo = () => {
  return (
    <div>
      <h1 className="size pt5 pb5">The Matrix</h1>
    </div>
  );
};

export default MatrixLogo;
